import { ChangeEvent } from 'react'
import { Slider, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  MAP_SLIDER_MAX,
  MAP_SLIDER_MAX_LABEL,
  MAP_SLIDER_MIN,
  MAP_SLIDER_MIN_LABEL,
  MAP_SLIDER_STEP,
} from 'src/constants'

import useStyles from './styles'

interface IProps {
  isDisabled?: boolean
  radius: number
  handleChangeRadius: (radius: number) => void
}

const SliderComponent = ({ radius, isDisabled, handleChangeRadius }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  const handleRadiusChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value)
    handleChangeRadius(value)
  }

  const handleRadiusOnChange = (event: any, value: number | number[]) => {
    if (typeof value === 'number') {
      handleChangeRadius(value)
    }
  }

  const marks = [
    {
      value: MAP_SLIDER_MIN,
      label: `${MAP_SLIDER_MIN_LABEL} ${t('metres-short-text.v')}`,
    },
    {
      value: MAP_SLIDER_MAX,
      label: `${MAP_SLIDER_MAX_LABEL} ${t('kilometres-short-text.v')}`,
    },
  ]

  return (
    <div className={classes.slideWrapper}>
      <div className={classes.sliderWrapper}>
        <Slider
          disabled={isDisabled}
          min={MAP_SLIDER_MIN}
          max={MAP_SLIDER_MAX}
          step={MAP_SLIDER_STEP}
          className={classes.slider}
          marks={marks}
          value={radius ? radius : MAP_SLIDER_MIN}
          onChange={handleRadiusOnChange}
          valueLabelFormat={(value) => (
            <div>{`${value} ${t('steps-form-radius-input-value.v')}`}</div>
          )}
        />
      </div>
      <TextField
        disabled={isDisabled}
        autoComplete="off"
        fullWidth
        className={classes.slideInput}
        id="radius-input"
        label={`${t('steps-form-radius-input-label.v')} (${t('metres-short-text.v')})`}
        type="number"
        InputLabelProps={{ shrink: true, className: classes.inputLabel }}
        value={radius}
        onChange={handleRadiusChange}
        variant="standard"
      />
    </div>
  )
}

export { SliderComponent as Slider }
